import { ApiProperty } from "@nestjs/swagger";

export class AssetsPoByIdDto{
    @ApiProperty()
    purchaseOrderId:number;
}